import http from '@/helpers/http'

function extractMenuList (payload) {
  if (Array.isArray(payload)) return payload
  if (!payload || typeof payload !== 'object') return []
  if (Array.isArray(payload.data)) return payload.data
  if (Array.isArray(payload.menus)) return payload.menus
  if (Array.isArray(payload.result)) return payload.result
  if (Array.isArray(payload.items)) return payload.items
  return []
}

export default {
  async getMenusByTenant () {
    const response = await http.get('/menu/roleAndTenant')
    return extractMenuList(response && response.data)
  }
}



// WEBPACK FOOTER //
// ./src/services/menuService.js